import React from 'react'
import { Router } from '@reach/router'
import 'antd/dist/antd.dark.css'
import './App.scss'
import 'react-vis/dist/style.css';
import Main from './modules/main'
import Login from './modules/login'
import PLReportByMarket from './modules/pl-report-by-market'
import PLReportByMarketBets from './modules/pl-report-by-market-bets'
import MarketAnalysis from './modules/market-analysis'
import IpReport from './modules/ip-report'
import OddsAnalyzer from './modules/odds-analyzer'
import SpikesAnalyzer from './modules/spikes-analyzer'

import { AppContextProvider } from './services/app-context'

function App() {
  return (
    <div className="App">
      <AppContextProvider>
        <Router>
          <Main path="/">
            <PLReportByMarket default path="pl-report-by-market" />
            <PLReportByMarketBets path="market-bets/:marketId/:currency" />
            <MarketAnalysis path="market-analysis/:marketId" />
            <IpReport path="ip-report" />
            <OddsAnalyzer path="odds-analyzer" />
            <SpikesAnalyzer path="spikes-analyzer/:marketId" />
          </Main>
          <Login path="/login" />
        </Router>
      </AppContextProvider>
    </div>
  )
}

export default App
